@import 'styles/mixins';
@import 'styles/variables';

.antModalOverrides {
  :global .ant-modal-body {
    @include for-desktop-up {
      width: 650px;
    }

    @include for-phone-only {
      width: calc(100vw - 16px);
    }
    border-radius: 8px;
    padding: 0;
  }
  :global .ant-modal-content {
    border-radius: 8px;
  }
}

.headerContainer {
  align-items: center;
  box-shadow: 0px 1px 0px #edeef0;
  display: flex;
  justify-content: space-between;
  padding: 14px 24px;
}

.header {
  @include xl-semibold;
  color: $almanac-black;
  margin-bottom: 0;
  margin-right: 15px;
}

.close {
  margin-bottom: 0;
  margin-left: auto;
  font-size: 20px;
  &:hover {
    cursor: pointer;
  }
}

.body {
  padding: 20px 24px 24px;
}

.overlay {
  position: absolute;
  top: 58px;
  right: 0;
  left: 0;
  bottom: 0;
  background: grey;
  z-index: 100;
  opacity: 0.1;
}
